import { AppStreamEnvironment } from '../models/AppStreamEnvironment';

export class GetAppStreamEnvironmentsResponse {
  appStreamEnvironments?: AppStreamEnvironment[];
}
